import React from 'react';
import {useTranslations} from 'next-intl';
import Container from '@/container';
import PictureWrapper from '@/ui/images-wrapper';
import {Grid, Row, Col} from '@/grid';
import {SectionPaddingHomeHero} from '@/section';
import {withGreen800, withNeutral700, withNeutral800, withBgNeutral200} from '@/hocs/withColors';
import {withHomeSubP, withHeadingEyebrow} from '@/hocs/withFontType';
import {withMarginBottomZeroToSm} from '@/hocs/withSpacing';
import {H1, P} from '@/typography';
import Link from '@/links';
import styles from './styles.module.scss';

const H1Green800 = withGreen800(H1);
const EyebrowNeutral700 = withNeutral700(withHeadingEyebrow(P));
const SubPNeutral800 = withNeutral800(withHomeSubP(P));
const Neutral200Div = withBgNeutral200('div');
const CtaDefaultMarginedMob = withMarginBottomZeroToSm(Link);
const imgPath = '/static/images/home/hero/';

const responsiveImages = {
  desktopImageUrl: 'hero-illustration-homepage-desktop',
  mobileImageUrl: 'hero-illustration-homepage-mobile'
};

const HomeHero = () => {
  const t = useTranslations('homepage.hero');
  const shared = useTranslations('shared');

  return (
    <Neutral200Div>
      <SectionPaddingHomeHero>
        <Container variant="section-padding-below-nav">
          <div data-testid="home-hero-banner">
            <Grid fluid>
              <Row center="xs" start="lg" middle="lg">
                <Col xs={12} lg={7}>
                  <EyebrowNeutral700>{t('eyebrow')}</EyebrowNeutral700>
                  <H1Green800>{t('title')}</H1Green800>
                  <SubPNeutral800>{t('subtitle')}</SubPNeutral800>
                  <ul className={styles['list-inline-to-bl']}>
                    <li>
                      <CtaDefaultMarginedMob
                        href="/free-trial"
                        variant="cta-default-xs"
                        customAttributes={{
                          'data-gtm': 'generic-body-free-trial',
                          'data-ui': 'homepage-free-trial'
                        }}>
                        {shared('freeTrialCTALabel')}
                      </CtaDefaultMarginedMob>
                    </li>
                    <li>
                      <Link
                        href="/demo"
                        variant="primary"
                        customAttributes={{
                          'data-gtm': 'generic-body-demo',
                          'data-ui': 'homepage-demo'
                        }}>
                        {shared('demoCTALabel')}
                      </Link>
                    </li>
                  </ul>
                </Col>
                <Col xs={12} lg={5}>
                  <div className={styles.hero__wrapper}>
                    <PictureWrapper
                      imgPath={imgPath}
                      responsiveImages={responsiveImages}
                      imageTypeFallback="jpg"
                      altImage={t('imageAlt')}
                      fetchpriority="high"
                      loading="eager"
                      width={480}
                      height={624}
                    />
                  </div>
                </Col>
              </Row>
            </Grid>
          </div>
        </Container>
      </SectionPaddingHomeHero>
    </Neutral200Div>
  );
};

export default HomeHero;
